export enum COMMON_COMPONENT_TYPES {
  NavBar = "NavBar",
}

export enum COMPONENT_TYPES {
  NavBar = "NavBar",
  FirstFold = "FirstFold",
  VideoSlider = "BannerSlider",
  OnboardingSection = "OnboardingJourney",
  Discover = "SelCatList",
  CareTeam = "ApolloCareTeam",
  ToolsWidget = "ToolsWidget",
  QuickReads = "ArtBySelCatSlid",
  DoctorRecommendation = "DoctorRecommendation",
  Shop = "ShopByCatWid",
  TrendingReads = "TrendingReads",
  ExpertContent = "ExpertContent",
  WeeklyChanges = "WeeklyChanges",
  FAQ = "FaqListWithCat",
  FaqListWithTitle = "FaqListWithTitle",
  ArticlesByTag = "ArticlesByTag",
  DynamicClusters = "DynamicClusters",
  Banner = "AyurvedicCare",
  FAQWithTitle = "FaqListWithTitle",
  DynamicArticles = "DynamicArticles",
  BannerWithCard = "BannerWithCard",
  BannerWithDesc = "BannerWithDesc",
  ClusterList = "ClusterList",
  VideoWidget1 = "VideoWidget1",
  ContentImageDesc = "ContentImageDesc",
  ClusterActionCards = "ClusterActionCards",
  ContentDescription = "ContentDescription",
  TopTips = "TopTips",
  ArticlesWithTagSlider = "ArticlesWithTagSlider",
  Index = "Index",
  ShopByCatSlider = "ShopByCatSlider",
  ShopByProdId = "ShopByProdId",
  ResourceArticles = "ResourceArticles",
  CategoryList = "CategoryList",
  ResourceVideos = "ResourceVideos",
  DoctorConsult = "DoctorConsult",
  ToolsCalculator = "CalcInput",
  Quote = "Quote",
  LabTest = "LabTest",
  VidCatSli = "VidCatSli",
  DynamicVideos = "DynamicVideos",
}

export const APPOINTMENT_URL = "https://www.apollo247.com/specialties/obstetrics-and-gynaecology?source=search_box";

export const HOME_PAGE_TITLE = "Home";
export const ONBOARDED_HOME_PAGE_TITLE = "For you";

export const FALLBAK_SEO_DATA = {
  title: "Mom Baby Web",
  description: "Apollo - Mom Baby Web",
};

export const TYPE_ARTICLE = "article";
export const TYPE_VIDEO = "video";

export const TOOLS_SLUG = {
  DUE_DATE: "due-date-calculator",
  OVULATION: "ovulation-calculator",
};

export const TOOLS_SESSION_MAPPING = {
  [TOOLS_SLUG.DUE_DATE]: "dueDateCalculatorData",
  [TOOLS_SLUG.OVULATION]: "ovulationCalculatorData",
};

export const FILTER_MAPPING = {
  category: "c",
  pillar: "p",
  cluster: "cl",
  tag: "t",
};

export const PREGNANCY_CIRCLE_END_VALUE = 40;
export const ONBOARDING_STATUS = {
  PreconceptionHome: "Preconception",
  PregnancyHome: "Pregnancy",
  MotherHome: "Newborn And Infant",
  BirthHome: "Pregnancy",
};
export const NON_ONBOARDED_STATUS = "Non Onboarded";

export const EVENT_NAMES = {
  HOME_PAGE_VIEWED: "Momverse Homepage Viewed",
  CATEGORY_PAGE_VIEWED: "Momverse Category Viewed",
  PILLAR_PAGE_VIEWED: "Momverse Pillar Page Viewed",
  CLUSTER_PAGE_VIEWED: "Momverse Cluster Page Viewed",
  CONTENT_VIEWED: "Momverse Content Viewed",
  BUTTON_CLICKED: "Momverse Button Clicked",
  POPUP_VIEWED: "Momverse Popup Viewed",
  DATE_ADDED: "Momverse Date Added",
  ASSET_CLICKED: "Momverse Asset Clicked",
  LOGIN_DONE: "Login Done",
  REGISTRATION_DONE: "Registration Done",
};

export const CONTENT_PAGES = ["article", "video"];

export const PRECONCEPTION_DATE_POPUP = "Last Period Date Selection Popup - Preconception";
export const PRECONCEPTION_AVERAGE_CYCLE_POPUP = "Average Cycle Selection Popup - Preconception";
export const FLOW_SELECTION_POPUP = "Onboarding Flow Selection Popup";
export const LOGIN_EVENT_KEY = "login_done_event";
export const FAB_DATA_COMPONENT = "floating-action-button.floating-action-button";
